var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnreal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_811_670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 2.37643C76.2833 2.37643 97.6236 23.7643 97.6236 50C97.6236 76.2357 76.2357 97.6236 50 97.6236C23.7643 97.6236 2.37643 76.2833 2.37643 50C2.37643 23.7167 23.7643 2.37643 50 2.37643ZM50 0C22.3859 0 0 22.3859 0 50C0 77.6141 22.3859 100 50 100C77.6141 100 100 77.6141 100 50C100 22.3859 77.6616 0 50 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5305 20.057C46.5305 20.057 35.2663 23.2414 25.1427 33.9829C15.0191 44.7243 13.7358 52.3764 13.7358 58.0798C15.9697 54.2775 29.753 33.3175 32.9849 43.2985V67.1578C32.9849 67.1578 32.7948 70.3897 27.8518 69.1064C29.3252 71.8631 36.9298 78.6597 50.6655 80.038C53.8024 76.9011 57.8898 72.3859 57.8898 72.3859L64.7339 78.1844C64.7339 78.1844 77.0438 70.1996 81.8917 58.6026C77.3765 61.5494 71.9107 68.3935 69.059 63.5931V34.5532C69.059 34.5532 76.3784 23.5741 77.5191 23.0513C74.6199 23.5741 64.4012 26.9486 59.0305 33.8878C57.5096 32.2243 53.2796 32.1768 53.2796 32.1768C53.2796 32.1768 56.6066 34.9334 56.6541 37.4524C56.7016 39.9715 56.6541 60.9791 56.6541 63.403C54.3727 65.7319 51.9488 66.9677 50.3803 66.9677C46.7206 66.9677 45.675 65.6844 44.6769 64.4011V33.8878C44.6769 33.8878 42.8708 35.4087 41.445 32.9372C40.0191 30.4658 39.9716 25.6654 46.5305 20.057Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_811_670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreal);
export default __webpack_public_path__ + "static/media/unreal.60786b2f589577cf9f1b83178f5d4a1b.svg";
export { ForwardRef as ReactComponent };